import { FC } from "react";

import { Alert, Box, CodeSnippet } from "@hightouch/htui";

import { Markdown } from "src/ui/markdown";
import { Context, Permissions } from "./constants";

type AdditionalPermissionsProps = {
  ctx: Context;
  permissions: NonNullable<Permissions["default"] | Permissions["lightning"]>;
};

export const AdditionalPermissions: FC<
  Readonly<AdditionalPermissionsProps>
> = ({ permissions, ctx }) => {
  return (
    <Alert
      variant="inline"
      type="warning"
      title="Additional permissions are required. Please modify and run the snippet below."
      message={
        <>
          <Markdown>{permissions.reason(ctx)}</Markdown>

          {permissions.code.length > 0 && (
            <Box
              display="flex"
              flexDirection="column"
              gap={3}
              mt={3}
              sx={{ pre: { whiteSpace: "pre-wrap" } }}
            >
              {permissions.code.map((codeBlock) => (
                <CodeSnippet
                  key={codeBlock.title(ctx)}
                  code={codeBlock.code(ctx)}
                  label={
                    permissions.code.length > 1
                      ? codeBlock.title(ctx)
                      : undefined
                  }
                />
              ))}
            </Box>
          )}
        </>
      }
    />
  );
};
